import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import * as $ from './../../../assets/js/jquery.min.js';
import { RouteConsts } from 'src/app/common/route-consts.js';
import { G_SaleMasterViewModel } from 'src/app/viewmodels/g-sale/G_SaleMasterViewModel.js';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service.js';
import { GetCountsForDashboardResponse } from 'src/app/viewmodels/g-settings/DasboardCountViewModel.js';
import { LocalStorageService } from 'src/app/services/common/local-storage.service.js';
declare var $: any;


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  public dashboardVM: GetCountsForDashboardResponse;
  public _routeConsts = new RouteConsts();
  @Input() public vm: G_SaleMasterViewModel;
  constructor(
    private _uow: UnitOfWorkService,public _localService: LocalStorageService
    ) {

   }

  ngOnInit() {
    debugger
    this.dashInit();
  }

  ngAfterViewInit() {

    // $('.datatable').DataTable();
  }

  dashInit() {
    debugger
    this._uow.gDashboardService.getCountsForDashboard().subscribe((res: any) => {
      debugger
      this.dashboardVM = res;
      console.log(res);
    }, (err) => {
      console.log(err);
    });
  }
}
